import React, { useEffect, useRef, useState } from "react";
import { LOGO } from "@/constants/media";

export function LogoMark({ className = "h-12 w-12", withText = false, size = "text-2xl" }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img src={LOGO} alt="The D logo" className={`${className} object-contain mix-blend-screen`} />
      {withText && (
        <div className="leading-none">
          <div className={`font-serif ${size} text-gold tracking-brand`}>THE D</div>
          <div className="text-[9px] tracking-label uppercase text-muted-foreground mt-1">Private Resort &amp; Social House</div>
        </div>
      )}
    </div>
  );
}

export function WordMark({ size = "text-3xl", subtitle = true }) {
  return (
    <div className="text-center">
      <div className={`font-serif ${size} text-gold tracking-brand`}>THE D</div>
      {subtitle && <div className="text-[10px] tracking-label uppercase text-muted-foreground mt-2">Private Resort &amp; Social House</div>}
    </div>
  );
}

// Fade/slide-in on scroll
export function Reveal({ children, delay = 0, className = "" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setShown(true); obs.disconnect(); } },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} className={className}
      style={{ opacity: shown ? 1 : 0, transform: shown ? "translateY(0)" : "translateY(28px)",
        transition: `opacity .9s cubic-bezier(.16,1,.3,1) ${delay}s, transform .9s cubic-bezier(.16,1,.3,1) ${delay}s` }}>
      {children}
    </div>
  );
}

export function GoldRule({ className = "" }) {
  return <div className={`gold-line ${className}`} />;
}
